<template>
  <login-view />
</template>

<script>
/*Login view wrapper*/

// components
import LoginView from '../../views/login/Login';

export default {
  name: "Login",
  components: {
    LoginView,
  }
}
</script>

